// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  verify: path(ROOTS_AUTH, "/verify"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  page404: "/404",
  page500: "/500",
  components: "/components",
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    courierDashboard: path(ROOTS_DASHBOARD, "/courier-dashboard"),
    schoolOrder: path(ROOTS_DASHBOARD, "/school-wise-order"),
    globalSearchOrder: path(ROOTS_DASHBOARD, "/global-search"),
    orderPromotion: path(ROOTS_DASHBOARD, "/variation-bulk"),
    parentList: path(ROOTS_DASHBOARD, "/parent"),
    studenstList: path(ROOTS_DASHBOARD, "/students-list"),
    tickets: path(ROOTS_DASHBOARD, "/tickets"),
    orderStatus: path(ROOTS_DASHBOARD, "/order-status"),
    archival: path(ROOTS_DASHBOARD, "/archival"),
    raisedTicket: path(ROOTS_DASHBOARD, "/raised-ticket"),
    studentSizing: path(ROOTS_DASHBOARD, "/student-sizing"),
    adminOrder: path(ROOTS_DASHBOARD, "/place-order"),
  },

  master: {
    root: path(ROOTS_DASHBOARD, "/master"),
    category: path(ROOTS_DASHBOARD, "/master/category"),
    house: path(ROOTS_DASHBOARD, "/master/house"),
    variation: path(ROOTS_DASHBOARD, "/master/variation"),
    vendor: path(ROOTS_DASHBOARD, "/master/vendor"),
    package: path(ROOTS_DASHBOARD, "/master/package"),
    product: path(ROOTS_DASHBOARD, "/master/product"),
    shipping: path(ROOTS_DASHBOARD, "/master/shipping"),
    standard: path(ROOTS_DASHBOARD, "/master/standard"),
    school: path(ROOTS_DASHBOARD, "/master/school"),
    ticketCategory: path(ROOTS_DASHBOARD, "/master/ticket-category"),
    promocode: path(ROOTS_DASHBOARD, "/master/promocode"),
    publisher: path(ROOTS_DASHBOARD, "/master/publisher"),
    party: path(ROOTS_DASHBOARD, "/master/party"),
  },
  reports: {
    root: path(ROOTS_DASHBOARD, "/reports"),
    studentSizingReport: path(ROOTS_DASHBOARD, "/reports/student-sizing-report"),
    orderSummary: path(ROOTS_DASHBOARD, "/reports/order-summary"),
    testReport: path(ROOTS_DASHBOARD, "/reports/test-report"),
    newReport: path(ROOTS_DASHBOARD, "/reports/new-report"),
    newAndPending: path(ROOTS_DASHBOARD, "/reports/new-and-pending-report"),
    studentwisependingReport: path(ROOTS_DASHBOARD, "/reports/student-wise-pending-report"),
    schoolwisependingReport: path(ROOTS_DASHBOARD, "/reports/school-wise-pending-report"),
    dateWiseReport: path(ROOTS_DASHBOARD, "/reports/date-wise-report"),
    orderWiseGSTReport: path(ROOTS_DASHBOARD, "/reports/order-wise-gst-report"),
    salesWithGst: path(ROOTS_DASHBOARD, "/reports/sale-with-gst"),
    salesWithOutGst: path(ROOTS_DASHBOARD, "/reports/sale-without-gst-report"),
    shippingReport: path(ROOTS_DASHBOARD, "/reports/shipping-wise-report"),
    salesReport: path(ROOTS_DASHBOARD, "/reports/sales-report"),
    settlementReport: path(ROOTS_DASHBOARD, "/reports/settlement-report"),
  },
  inventory: {
    root: path(ROOTS_DASHBOARD, "/inventory"),
    dashboard: path(ROOTS_DASHBOARD, "/inventory/dashboard"),
    draftOrder: path(ROOTS_DASHBOARD, "/inventory/draft-order"),
    purchaseOrder: path(ROOTS_DASHBOARD, "/inventory/purchase-order"),
    outWard: path(ROOTS_DASHBOARD, "/inventory/outward-sale"),
    stockManage: path(ROOTS_DASHBOARD, "/inventory/stock-management"),
  },
  courier: {
    root: path(ROOTS_DASHBOARD, "/courier"),
    addCompany: path(ROOTS_DASHBOARD, "/courier/add-company"),
    addRider: path(ROOTS_DASHBOARD, "/courier/add-rider"),
    addDelivery: path(ROOTS_DASHBOARD, "/courier/add-delivery"),
    orderStatus: path(ROOTS_DASHBOARD, "/courier/order-status"),
    riderStatus: path(ROOTS_DASHBOARD, "/courier/rider-status"),
  },
};
